/*
  This class restricts the actual input of non allowed characters into a text field.
*/
import {
  Directive,
  Input,
  HostBinding,
  HostListener,
  Self,
  Inject,
  Optional,
  forwardRef,
  ElementRef,
} from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';

@Directive({
  selector: 'input[pgInputSanitizer], input[gritInputSanitizer]',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => PgInputSanitizerDirective),
      multi: true,
    },
  ],
})
export class PgInputSanitizerDirective implements ControlValueAccessor {
  @Input() pgInputSanitizer: RegExp;

  protected inputEl: HTMLInputElement;
  _onChange = (_: any) => {};
  _onTouched = () => {};

  constructor(private _elementRef: ElementRef) {
    this.inputEl = _elementRef.nativeElement;
  }

  @HostListener('blur', ['$event']) blur($event) {
    this._onTouched();
  }

  @HostListener('input', ['$event']) input($event) {
    this.updateValue();
  }

  updateValue() {
    const newVal = this.format(this.inputEl.value);
    this.inputEl.value = newVal;
    this._onChange(newVal);
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn || (() => {});
  }

  registerOnChange(fn: (value: any) => any): void {
    this._onChange = fn;
  }

  writeValue(value: any) {
    this.inputEl.value = value;
    if (value) {
      setTimeout(() => {
        this.updateValue();
      });
    }
  }

  protected format(value: string): string {
    if (this.pgInputSanitizer) {
      return value
        .split('')
        .reduce(
          (acc, char, i) =>
            this.pgInputSanitizer.test(char) ? acc + char : acc,
          ''
        );
    }
  }
}
